import { React, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
  Alert,
} from "reactstrap";
import errors from "../../Constants/errors.json";
import Modal from "react-modal";
import Mapping from "../../Utils/Mapping";
import {
  // getRequestDetails,
  rejectRequest,
  approveRequest,
} from "../../../actions/request";
import { CustomDialog } from "../../Utils/utils";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import SearchResults from "../../Utils/SearchResults";
import { AiFillDownCircle, AiFillUpCircle } from "react-icons/ai";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    border: "8px solid #9ba5ad",
    maxHeight: "100vh",
    overflowY: "auto",
  },
};

function RequestDetails(props) {
  const dispatch = useDispatch();
  const [currState, setCurrState] = useState({
    modal: false,
    isCommentRequired: false,
    collapse: false,
    company: "",
    commentsval: null,
    btnName: "",
  });

  // do this later
  // this.togglePanel = this.togglePanel.bind(this);

  const { requestDetails, success, rejectedDetails } = useSelector(
    (state) => state?.requests
  );

  const error = useSelector((state) => state?.error?.error_obj);

  let [userError, setUserError] = useState("");

  const rowDetails = props.rowDetails;

  // const getRequestDetailsFn = (username) => {
  //   dispatch(getRequestDetails(username));
  // };
  const rejectRequestFn = (username, details, comments) => {
    dispatch(rejectRequest(username, details, comments));
  };
  const approveRequestFn = (username, details) => {
    dispatch(approveRequest(username, details));
  };
  // const clearRequestDetailsFn = () =>
  //   dispatch({
  //     type: "SET_REQUEST_DETAIL",
  //     data: { requestDetails: undefined },
  //   });

  const requestAction = (action) => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        commentsval: null,
        btnName: action,
      };
    });
    toggle();
  };

  var errorMessage =
    (error && error.code && error.code.message && error.code.message.code) ||
    (error && error.message) ||
    (error && <Mapping dictionary={errors} word={error.errorPath} />);

  useEffect(() => {
    if (errorMessage !== "" || errorMessage !== undefined) {
      setUserError(errorMessage);
    }
  }, [errorMessage]);

  useEffect(() => {
    return () =>
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  }, []);

  useEffect(() => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        company: requestDetails["custom_company"],
      };
    });
    return () => {
      dispatch({
        type: "SET_REQUEST_DETAIL",
        data: { requestDetails: undefined },
      });
    };
  }, [requestDetails, dispatch]);

  const modalButtonClick = (btnName) => {
    // const { rowDetails, requestDetails } = this.props;
    let distAccount =
      requestDetails &&
      requestDetails.custom_distributoraccount &&
      requestDetails.custom_distributoraccount.join(",");
    let approveData = requestDetails;
    approveData["distributorAccount"] = distAccount;
    approveData["custom_company"] = currState?.company
      ? String(currState?.company).trim()
      : approveData["custom_company"];
    approveData["name"] = currState?.company
      ? String(currState?.company).trim()
      : approveData["name"];
    if (btnName === "Reject" && currState?.commentsval) {
      rejectRequestFn(rowDetails.email, requestDetails, currState?.commentsval);
      toggle();
    } else if (btnName === "Reject" && !currState?.commentsval) {
      setCurrState((prevState) => {
        return {
          ...prevState,
          isCommentRequired: true,
        };
      });
    } else if (btnName === "Approve") {
      approveRequestFn(rowDetails.email, approveData);
      toggle();
    } else {
      // console.log('NO BUTTON AVAILABLE');
      toggle();
    }
  };

  const toggle = () => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        modal: !currState.modal,
      };
    });
    if (!currState.modal) {
      setCurrState((prevState) => {
        return {
          ...prevState,
          isCommentRequired: false,
        };
      });
    }
  };

  const togglePanel = (e) => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        collapse: !currState.collapse,
      };
    });
  };
  const handleTextAreaChange = (event) => {
    // setCurrState({
    //   ...currState,
    //   commentsval: event.target.value,
    //   isCommentRequired: false,
    // });
    setCurrState((prevState) => {
      return {
        ...prevState,
        commentsval: event.target.value,
        isCommentRequired: false,
      };
    });
  };

  const columns = [
    {
      Header: "Reviewed By",
      accessor: "rejected_by_name",
    },
    {
      Header: `Reviewer's Email`,
      accessor: "rejected_by_email",
    },
    {
      Header: "Rejection Reason",
      accessor: "rejected_comments",
    },
    {
      Header: "Rejection Date",
      accessor: "rejected_date",
    },
  ];

  // let productTypeData =
  // 	requestDetails && requestDetails.product_type && requestDetails.product_type.replace(/,/g, '\n');
  //let distributorData =
  //requestDetails && requestDetails.custom_distributoraccount && requestDetails.custom_distributoraccount.join('\n');
  // let companyBuyData = distributorData ? `${distributorData}` : '';

  // if (success) props.MainToggle();
  const MainToggle = props.MainToggle;
  useEffect(() => {
    if (success) MainToggle();
  }, [success, MainToggle]);

  let icon = rejectedDetails ? (
    <AiOutlineExclamationCircle style={{ color: "red", fontSize: "30px" }} />
  ) : null;

  let headerText =
    currState?.btnName === "Reject"
      ? `${currState?.btnName}`
      : `${currState?.btnName} request`;
  let messageText =
    currState?.btnName === "Approve" &&
    `Do you want to ${currState?.btnName} ?`;
  let confirmButton = currState?.btnName === "Reject" ? "REJECT" : "OK";

  return (
    <>
      <Modal
        isOpen={props.MainModal}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.MainToggle}
      >
        <Container fluid>
          {requestDetails && (
            <>
              <Form>
                <div
                  style={{ float: "Right", cursor: "pointer" }}
                  onClick={(e) => props.MainToggle()}
                >
                  <b>X</b>
                </div>
                <h5>Request Details {icon}</h5>

                <hr />
                {userError && (
                  <Alert color="danger" style={{ textAlign: "center" }}>
                    {/* <h5>{errorMessage}</h5> */}
                    <h5>{userError}</h5>
                  </Alert>
                )}
                {/* {currState?.btnName && (
               <CustomDialog
                 modal={currState?.modal}
                 btnName={currState?.btnName}
                 header={headerText}
                 message={messageText}
                 toggle={toggle}
                 button1fun={() => modalButtonClick(currState?.btnName)}
                 textarefun={handleTextAreaChange}
                 textarealabel={"Reason for rejection"}
                 showTextArea={currState?.btnName === "Reject"}
                 confirmButton={confirmButton}
                 commentRequired={currState?.isCommentRequired}
               />
             )} */}
                <CustomDialog
                  modal={currState?.modal}
                  btnName={currState?.btnName}
                  header={headerText}
                  message={messageText}
                  toggle={toggle}
                  button1fun={() => modalButtonClick(currState?.btnName)}
                  textarefun={handleTextAreaChange}
                  textarealabel={"Reason for rejection"}
                  showTextArea={currState?.btnName === "Reject"}
                  confirmButton={confirmButton}
                  commentRequired={currState?.isCommentRequired}
                />
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="email" id="email" className="label">
                        Email ID:
                      </Label>
                      <Label for="emailVal" id="emailVal">
                        {requestDetails.email}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="company" id="company" className="label">
                        Company:
                      </Label>
                      {/* <Label for='companyVal' id='companyVal'>
                       {requestDetails.custom_company}
                     </Label> */}
                      <Input
                        type="text"
                        value={currState?.company}
                        onChange={(e) => {
                          // setCurrState({ ...currState, company: e.target.value });
                          setCurrState((prevState) => {
                            return {
                              ...prevState,
                              company: e.target.value,
                            };
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="firstName" id="firstName" className="label">
                        First Name:
                      </Label>
                      <Label for="firstNameVal" id="firstNameVal">
                        {requestDetails.given_name}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="lastName" id="lastName" className="label">
                        Last Name:
                      </Label>
                      <Label for="lastNameVal" id="lastNameVal">
                        {requestDetails.family_name}
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  {/* <Col sm={6}>
                   <FormGroup>
                     <Label for='company' id='company' className='label'>
                       Company:
                     </Label>
                     <Label for='companyVal' id='companyVal'>
                       {requestDetails.custom_company}
                     </Label>
                   </FormGroup>
                 </Col> */}
                  <Col sm={6}>
                    <FormGroup>
                      <Label
                        for="mobileNumber"
                        id="mobileNumber"
                        className="label"
                      >
                        Mobile Number:
                      </Label>
                      <Label for="mobileNumberVal" id="mobilrNumberVal">
                        {requestDetails.phone_number}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label
                        for="phoneNumber"
                        id="phoneNumber"
                        className="label"
                      >
                        Company Phone Number:
                      </Label>
                      <Label for="phoneNumberVal" id="phoneNumberVal">
                        {requestDetails.custom_telephone}
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='SapContactId' id='SapContactId' className='label'>
                       SAP Contact id:
                     </Label>
                     <Label for='SapContactIdVal' id='SapContactIdVal'>
                       {requestDetails.custom_sapcontactid}
                     </Label>
                   </FormGroup>
                 </Col>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='SapAccountId' id='SapAccountId' className='label'>
                       SAP Account id:
                     </Label>
                     <Label for='SapAccountIdVal' id='SapAccountIdVal'>
                       {requestDetails.custom_sapAccountid}
                     </Label>
                   </FormGroup>
                 </Col>
               </Row>
               <Row>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='ResourceId' id='ResourceId' className='label'>
                       Resource ID:
                     </Label>
                     <Label for='ResourceIdVal' id='ResourceIdVal'>
                       {requestDetails.custom_resourceid}
                     </Label>
                   </FormGroup>
                 </Col>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='ContractType' id='ContractType' className='label'>
                       Contract Type:
                     </Label>
                     <Label for='ContractTypeVal' id='ContractTypeVal'>
                       {requestDetails.custom_contracttype}
                     </Label>
                   </FormGroup>
                 </Col>
               </Row>  */}
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="City" id="City" className="label">
                        City:
                      </Label>
                      <Label for="CityVal" id="CityVal">
                        {requestDetails.custom_city}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="State" id="State" className="label">
                        State:
                      </Label>
                      <Label for="StateVal" id="StateVal">
                        {requestDetails.custom_state}
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="Zip" id="Zip" className="label">
                        Zip/Postal Code:
                      </Label>
                      <Label for="ZipVal" id="ZipVal">
                        {requestDetails.custom_zip}
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="Country" id="Country" className="label">
                        Country:
                      </Label>
                      <Label for="CountryVal" id="CountryVal">
                        {requestDetails.custom_country}
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='SalesOrg' id='SalesOrg' className='label'>
                       Sales Org:
                     </Label>
                     <Label for='SalesOrgVal' id='SalesOrgVal'>
                       {requestDetails.custom_salesOrg}
                     </Label>
                   </FormGroup>
                 </Col>
               </Row> */}
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="Address" id="Address" className="label">
                        Address:
                      </Label>
                      <Input
                        type="textarea"
                        disabled
                        value={requestDetails.address}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup>
                      <Label for="accessrole" id="accessrole" className="label">
                        Access Role(s):
                      </Label>
                      <Input
                        type="textarea"
                        disabled
                        value={requestDetails.custom_Groups}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row>
                  <Col sm={6}>
                   <FormGroup>
                     <Label for='productSold' id='productSold' className='label'>
                       Products sold by your company:
                     </Label>
                     <Input type='textarea' disabled value={productTypeData} />
                   </FormGroup>
                 </Col>
                 <Col sm={6}>
                   <FormGroup>
                     <Label for='companyBuys' id='companyBuys' className='label'>
                       Your company buys sony products:
                     </Label>
                     <Input type='textarea' disabled value={companyBuyData} />
                   </FormGroup>
                 </Col> 
               </Row> */}
                <Row>
                  {rejectedDetails && (
                    <Col sm={12}>
                      <FormGroup>
                        <div>
                          <span style={{ fontWeight: "bold" }}>
                            Rejection History
                          </span>
                          <span
                            onClick={(e) => togglePanel(e)}
                            className="rejectedDetailsHeaderCollapse"
                          >
                            {!currState?.collapse ? (
                              <AiFillUpCircle />
                            ) : (
                              <AiFillDownCircle />
                            )}
                          </span>
                          {currState?.collapse ? (
                            <div className="rejectedDetailsContentCollapse">
                              <SearchResults
                                columns={columns}
                                data={rejectedDetails}
                                paginationNotRequired={true}
                              />
                            </div>
                          ) : null}
                        </div>
                      </FormGroup>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col sm={6}>
                    <FormGroup style={{ display: "flex" }}>
                      <Button
                        onClick={(e) => {
                          e.preventDefault();
                          requestAction("Reject");
                        }}
                        style={{
                          display: "center",
                          marginRight: "5px",
                          width: "165px",
                        }}
                      >
                        Reject
                      </Button>
                      <Button
                        onClick={(e) => {
                          e.preventDefault();
                          requestAction("Approve");
                        }}
                        style={{ width: "150px" }}
                      >
                        Approve
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </>
          )}
        </Container>
      </Modal>
    </>
  );
}

export default RequestDetails;
